import type { BadgeRule } from "~/lib/badges/types";

export const tagsRule: BadgeRule = {
  name: "tags",
  evaluate: (product, badge) => {
    if (!badge.criteriaTags.length) return true;
    return badge.criteriaTags.some((tag) => product.tags.includes(tag));
  },
};
